import React, { useContext, useRef, useState } from 'react'
import { default as SearchIcon } from '@assets/icons/search.svg?react'
import { useDebounce, useDropdownCloseListeners } from '@hooks/index'
import SearchPopup from './Popup'
import ThemeContext from '@contexts/themeContext'

import brandStyles from './../../_brand.module.scss'
import './Search.scss'
import ClientOnly from './../../../ClientOnly'
import type { SearchResultProps } from './type'

const SearchResult = React.lazy(() => import('./Result'));

type SearchProps = {
  isActive: boolean
  handleFocus: () => void
  handleUnfocus: () => void
}

function Search({ isActive, handleFocus, handleUnfocus }: SearchProps) {
  const ref = useRef<HTMLInputElement>(null)
  const [search, setSearch] = useState<string>('')
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }
  const containerRef = useRef<HTMLDivElement>(null)
  const deferredSearchTerm = useDebounce(search, 400)
  useDropdownCloseListeners(containerRef, handleUnfocus)

  const isDark = useContext(ThemeContext) === 'dark'

  return (<div ref={containerRef} className='wc-nav-search-container'>
    <div className={"wc-nav-search-inputContainer"}>
      <div className={`wc-nav-search-iconContainer ${isActive ? "wc-nav-search-iconContainerActive" : "wc-nav-search-iconContainerInactive"}`} onClick={() => { ref.current && ref.current.focus() }} data-testid='nav-search-trigger'>
        <SearchIcon className={"wc-nav-search-searchIcon"} width={20} fill={`${isDark ? brandStyles.space : brandStyles.shade}`} />
      </div>
      <input ref={ref} className={`wc-nav-search-input ${isDark ? "wc-nav-search-inputDark" : "wc-nav-search-inputLight"} ${isActive ? "wc-nav-search-inputActive" : "wc-nav-search-inputInactive"}`} placeholder='Start typing a supplier’s name…' onClick={handleFocus} onFocus={handleFocus} onChange={handleChange} data-testid='nav-search-input' />
    </div>
    {isActive && <div className={"wc-nav-search-dropdown"}>
      <SearchPopup>
        <ClientOnly<SearchResultProps> Component={SearchResult} query={deferredSearchTerm} />
      </SearchPopup>
    </div>}
  </div>)
}

export default Search
